import { Middleware } from '@reduxjs/toolkit'
import { logout, setUser } from '../authSlice'
import { baseApi } from './baseApi'

/**
 * Empties the RTK Query cache when the session ends: an explicit logout, or the user cleared (a failed verify). The next
 * person to sign in on this tab never sees the last one's lists.
 */
export const resetApiOnLogout: Middleware =
    ({ dispatch }) =>
    (next) =>
    (action) => {
        const result = next(action)
        if (logout.match(action) || (setUser.match(action) && action.payload === null)) dispatch(baseApi.util.resetApiState())
        return result
    }
